var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRow24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 52,
    viewBox: "0 0 43 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6748 24.7224H26.8036C28.1866 24.7224 29.3095 25.8453 29.3095 27.2283V28.1897C29.3095 29.5727 28.1866 30.6956 26.8036 30.6956H15.6748C14.2918 30.6956 13.1689 29.5727 13.1689 28.1897V27.2283C13.1689 25.8453 14.2918 24.7224 15.6748 24.7224Z",
    fill: "#00B1A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62086 19.4228C9.8815 19.4228 11.3272 19.4218 12.5406 19.4207L33.8697 19.4105L33.8574 -0.000976562L8.60852 0.0113625L8.62086 19.4228Z",
    fill: "#00B1A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31762 19.4238C6.60553 19.4238 6.96336 19.4238 7.3685 19.4238L7.35616 0.027832C5.42509 0.186184 3.90327 1.56816 3.9043 3.23599L3.91252 16.2044C3.91355 17.9761 4.99631 19.4249 6.31762 19.4249V19.4238ZM5.95053 9.03845C6.38754 9.03845 6.74126 9.33665 6.74126 9.70476C6.74126 10.0729 6.38754 10.3711 5.95053 10.3711C5.51352 10.3711 5.1598 10.0729 5.1598 9.70476C5.1598 9.33665 5.51352 9.03845 5.95053 9.03845Z",
    fill: "#00B1A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.575 16.1879L38.5668 3.21948C38.5658 1.55165 37.0419 0.170699 35.1108 0.0144043L35.1232 19.396C37.0542 19.2377 38.5761 17.8557 38.575 16.1879ZM37.1612 15.7066C37.1612 16.0521 36.8805 16.3328 36.535 16.3328C36.1895 16.3328 35.9088 16.0521 35.9088 15.7066V13.5216C35.9088 13.1761 36.1895 12.8954 36.535 12.8954C36.8805 12.8954 37.1612 13.1761 37.1612 13.5216V15.7066ZM35.9088 3.70482C35.9088 3.3583 36.1895 3.07861 36.535 3.07861C36.8805 3.07861 37.1612 3.35933 37.1612 3.70482V5.88987C37.1612 6.23639 36.8805 6.51608 36.535 6.51608C36.1895 6.51608 35.9088 6.23536 35.9088 5.88987V3.70482ZM36.535 8.75459C37.0604 8.75459 37.4851 9.18029 37.4851 9.7047C37.4851 10.2291 37.0594 10.6548 36.535 10.6548C36.0106 10.6548 35.5849 10.2291 35.5849 9.7047C35.5849 9.18029 36.0106 8.75459 36.535 8.75459Z",
    fill: "#00B1A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 48.7866C0 49.457 0.260149 50.0863 0.732119 50.5583L1.44059 51.2667C1.92901 51.7552 2.57064 51.9989 3.21228 51.9989C3.85391 51.9989 4.49554 51.7541 4.98396 51.2667L16.5621 39.6886V31.1838L0.732119 47.0149C0.260149 47.4869 0 48.1162 0 48.7866Z",
    fill: "#00B1A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7473 47.0151L25.9172 31.1851V39.6898L37.4954 51.268C37.9838 51.7564 38.6255 52.0001 39.2671 52.0001C39.9087 52.0001 40.5504 51.7553 41.0388 51.268L41.7473 50.5595C42.2192 50.0875 42.4794 49.4582 42.4794 48.7878C42.4794 48.1174 42.2192 47.4881 41.7473 47.0161V47.0151Z",
    fill: "#00B1A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2463 21.0176H18.233V23.0515H24.2463V21.0176Z",
    fill: "#00B1A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.233 49.5775C18.233 50.9132 19.3569 51.999 20.7389 51.999H21.7414C23.1234 51.999 24.2473 50.9122 24.2473 49.5775V32.3655H18.2341V49.5775H18.233Z",
    fill: "#00B1A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_90"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.4794,
    height: 52,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow24);
export default __webpack_public_path__ + "static/media/row2-4.b03762a6d91ff2da9733dc641b960cb0.svg";
export { ForwardRef as ReactComponent };